import React, { Component, cloneElement, useState } from 'react';
import { List, Pagination, Datagrid, TextField, ReferenceField, DateField, ShowButton, Filter, ReferenceInput, AutocompleteInput, TextInput, ExportButton, RefreshButton, TopToolbar, GET_ONE, usePermissions, useResourceContext } from 'react-admin';
import { Scrollbars } from 'react-custom-scrollbars';
import Spinner from '../../src/spinner';
import myDataProvider from '../myRestProvider';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from '../common/common'
import Modal from 'react-responsive-modal';
import Swal from 'sweetalert2';
import GetAppIcon from '@mui/icons-material/GetApp';
import { useLocation } from 'react-router-dom';

const ContractFilter = (props) => (
    <Filter {...props}>
        <ReferenceInput label="Sold To Name" source="business_id" reference="businesses" linkType="show" allowEmpty>
            <AutocompleteInput optionText="name" label="Sold To Name"  />
        </ReferenceInput>
        <TextInput source="contract_number" />
        <TextInput source="contract_type" defaultValue="" />
        <TextInput source="inco_term" defaultValue="" />
    </Filter>
);
class PostPanel extends Component {
    constructor(props) {
        super(props);
        this.fetchItem(props.record.retailer_info.id);
        this.reload = this.reload.bind(this);
        this.state = {
            open: false,
            showloader: true,
            reloadButton: false,
            data: {},
            dateFlag: false
        };
        console.log('id is', props.record.retailer_info.id)
        console.log('props is ', props)
    }
    render() {
        return (
            <div className="soldToDetails">
                <table>
                    <tr>
                    </tr>
                    <tr>
                        <th>SAP credit area Cd</th>
                        <th>Last SAP update</th>
                        <th>Currency</th>
                        <th>Credit limit</th>
                        <th>Credit exposure SAP</th>
                        <th>Credit exposure LOGON</th>
                        <th>Open credit LOGON</th>
                        <th>Orders not invoiced price</th>
                        <th>Digital order balance</th>
                    </tr>
                    <tr>
                        <td>{this.state.data.sap_credit_area_cd}</td>
                        <td >{this.state.lastSAPUpdate}</td>
                        <td>{this.state.data.currency}</td>
                        <td>{this.state.data.credit_limit}</td>
                        <td>{this.state.data.credit_exposure_sap}</td>
                        <td>{this.state.data.credit_exposure_logon}</td>
                        <td>{this.state.data.open_credit_logon}</td>
                        <td>{this.state.data.orders_not_invoiced_price}</td>
                        <td>{this.state.data.sap_digital_order_balance}</td>
                    </tr>
                    <tr>
                        <td className='errorMsg' colspan="9">{this.state.reloadButton && window.navigator.onLine &&
                            <div>{this.state.data.msgText}</div>
                        }</td>
                    </tr>
                    <tr>
                        <td className='spinner' colspan="9"><div className="spinner">
                            {this.state.showloader && window.navigator.onLine &&
                                <Spinner />
                            }
                        </div>
                            {this.state.reloadButton && window.navigator.onLine &&
                                <div className="refresh" >
                                    <i onClick={this.reload} class="material-icons">
                                        refresh
                       </i>
                                </div>
                            }
                            <div>
                                {!window.navigator.onLine &&
                                    <p>It seems that you are offline. Please check your internet connection</p>
                                }
                            </div>
                        </td>
                    </tr>
                </table>
            </div>
        )
    }
    reload() {
        this.setState({
            reloadButton: false,
            showloader: true
        }, () => this.fetchItem(this.props.record.retailer_info.id));
    }
    fetchItem = async (id) => {
        const json = await myDataProvider(GET_ONE, 'getSapDetails', { id });
        const item = json.data;
        console.log('items are', item);
        this.setState({ showloader: false })
        this.setState({ data: item })
        if (item.errorMsg === 'Reload') {
            this.state.reloadButton = true;
        }
        var countryTime = new Date(this.state.data.last_sap_update).toLocaleString("en-US");
        console.log('countryTime', countryTime);
        this.setState({ lastSAPUpdate: countryTime })
        if (this.state.lastSAPUpdate !== 'Invalid Date') {
            this.setState({ dateFlag: true })
        }
    }
}
const ContractsPagination = props => <Pagination rowsPerPageOptions={[10, 50, 100, 150, 200]} {...props} />

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

// const ListActions = ({ resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters }) => {
//     return (
//       <TopToolbar>
//         {filters && cloneElement(filters, {
//           resource,
//           showFilter,
//           displayedFilters,
//           filterValues,
//           context: 'button',
//         })}
//         <RefreshButton />
//         <ExportButton
//           disabled={total === 0}
//           resource={resource + '_csv'}
//           sort={currentSort}
//           filter={{ ...filterValues, ...permanentFilter }}
//           exporter={exporter}
//           maxResults={maxResults}
//         />
//       </TopToolbar>
//     )
// }

// const ListActions = (props) => {
//     const [modalShow, setModalShow] = React.useState(false);
//     const [modalMsg, setModalMsg] = React.useState('')
//     const { resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters } = props;
//     const csvResource = resource + '_csv'
//     const options = CommonHeaderOption();
//     const apiUrl = RUN_TIME_API_ENDPOINT;
    
//     const callExport = (e) => {
//       e.preventDefault();
//       console.log('...', window.location.href, `${apiUrl}/${resource}_csv`)
//       options.method = 'GET';
//       fetch(`${apiUrl}/${resource}_csv?filter=%7B%7D&range=%5B0%2C999%5D&sort=%5B"id"%2C"DESC"%5D`, options)
//         .then(res => {
//             return res.json();
//         }).then(jsonD => {
//           console.log('jsonD VVVVVVx===>', jsonD.data);
//           const msg = jsonD.data? jsonD.data[0].message : '';
//           setModalShow(true);
//           setModalMsg(msg);
//         });
//     }
//     const exporterModal = () => {
//       return ''
//     }
  
//     const onClose = () => {
//       setModalShow(false)
//     }
//     return (
//       <React.Fragment>
//       <TopToolbar>
//         {filters && cloneElement(filters, {
//           resource,
//           showFilter,
//           displayedFilters,
//           filterValues,
//           context: 'button',
//         })}
//         <RefreshButton />
//         <ExportButton
//           onClick={(e) => callExport(e)}
//           disabled={total === 0}
//           resource={csvResource}
//           sort={currentSort}
//           filter={{ ...filterValues, ...permanentFilter }}
//           exporter={exporterModal}
//           maxResults={maxResults}
//           />
//       </TopToolbar>
//       {
//             modalShow &&
//             <Modal open={modalShow} onClose={onClose} center> 
//               <h3>{modalMsg}</h3>
//             </Modal>
//       }
//       </React.Fragment>
//     )
//   }

const ListActions = (props) => {
      
    const location = useLocation();
    const resource = useResourceContext();
      const [ modalShow, setModalShow ] = useState(false);
      const [ modalMsg, setModalMsg ] = useState('');
      const [ customFilterUrl, setCustomFilterUrl ] = useState(
        location.search
    );

    const callExport = (e) => {
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;
        e.preventDefault();
        console.log('...', location.pathname, `${apiUrl}/${resource}_csv`)
        options.method = 'GET';
        let _url = location.pathname.split('?');
        if (_url.length > 1 && _url[1] !== '') {
          console.log('params found');
          setCustomFilterUrl(_url[1])
          fetch(`${apiUrl}/${resource}_csv?${_url[1]}`, options)
        .then(res => {
            return res.json();
        }).then(jsonD => {
          console.log('json= inside callback', jsonD.data);
          const msg = jsonD.data? jsonD.data[0].message : '';
          Swal.fire({
              html: msg,
              icon: 'success',
          })
        //   this.setState({ modalShow: true});
        //   this.setState({ modalMsg: msg});
      });
      } else {
        setCustomFilterUrl(location.search)
        fetch(`${apiUrl}/${resource}_csv?${location.search}`, options)
            .then(res => {
                return res.json();
            }).then(jsonD => {
              console.log('json= inside callback', jsonD.data);
              const msg = jsonD.data? jsonD.data[0].message : '';
              Swal.fire({
                  html: msg,
                  icon: 'success',
              })
            //   this.setState({ modalShow: true});
            //   this.setState({ modalMsg: msg});
          });
      }
    }
    const exporterModal = () => {
      return ''
    }
  
    const onClose = () => {
      setModalShow(false);
    }
    const { filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters } = props;
      const csvResource = resource + '_csv'
    return (
      <React.Fragment>
      <TopToolbar>
        {filters && cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
        <RefreshButton />
        {/* <ExportButton
          onClick={(e) => this.callExport(e)}
          disabled={total === 0}
          resource={csvResource}
          sort={currentSort}
          filter={{ ...filterValues, ...permanentFilter }}
          exporter={this.exporterModal}
          maxResults={maxResults}
          /> */}
          <div>
            <button className="export-button"
              onClick={(e) => callExport(e)}
              disabled={total === 0}
              sort={currentSort}
              filter={{ ...filterValues, ...permanentFilter }}
            >
              {<GetAppIcon />}
              <span>Export</span>
            </button>
          </div>
      </TopToolbar>
      {
            modalShow &&
            <Modal open={modalShow} onClose={onClose} center> 
              <h3>{modalMsg}</h3>
            </Modal>
      }
      </React.Fragment>
    )
  }
  
  

const ContractsList = (props) => {
    const permissions = usePermissions();
        return (
            <React.Fragment>
                <Scrollbars class="scroll-container" >
                <List pagination={<ContractsPagination />}  sort={{ field: 'created_at', order: 'DESC' }} filters={<ContractFilter />} actions={<ListActions props={props} />} title="Contracts List">
                        {/* <Datagrid rowClick="show" expand={permissions === 'isSap' && <PostPanel />}> */}
                        <Datagrid rowClick="show" bulkActionButtons={false}>
                            <TextField source="contract_number" />
                            <TextField source="contract_type" />
                            <ReferenceField label="Sold To Name" sortable={false} source="retailer_info.id" reference="businesses" link="show" allowEmpty>
                                <TextField source="name" />
                            </ReferenceField>
                            <TextField source="retailer_info.sap_code" label="Sold To ID" sortable={false} />
                            <DateField label="Contract Valid From" source="contract_valid_from" />
                            <DateField label="Contract Valid To" source="contract_valid_to" />
                            <TextField source="inco_term" />
                            <DateField label="Created at" source="created_at" sortable={false} />
                            <ShowButton />
                        </Datagrid>
                    </List>
                </Scrollbars>
                {/* {
                    state.moodalShow &&
                    <Modal open={state.moodalShow} onClose={this.onClose} center>
                        <h3>{state.modalMsg}</h3>
                    </Modal>
                } */}
            </React.Fragment>
        )
}

export default ContractsList;